import { API_BASE } from "../config/api-url";

const MAX_DIMENSION = 1280;
const MAX_DATA_URL_LENGTH = 900_000;
const IMAGE_DATA_URL_PATTERN = /^data:image\/[a-zA-Z0-9.+-]+;base64,/i;

function loadImageFromFile(file: File): Promise<HTMLImageElement> {
	return new Promise((resolve, reject) => {
		const objectUrl = URL.createObjectURL(file);
		const image = new Image();

		image.onload = () => {
			URL.revokeObjectURL(objectUrl);
			resolve(image);
		};

		image.onerror = () => {
			URL.revokeObjectURL(objectUrl);
			reject(new Error("No se pudo cargar la imagen de comprobante."));
		};

		image.src = objectUrl;
	});
}

export async function buildInlinePaymentSupport(file: File): Promise<string | null> {
	const image = await loadImageFromFile(file);
	const scale = Math.min(1, MAX_DIMENSION / Math.max(image.width, image.height));
	const width = Math.max(1, Math.round(image.width * scale));
	const height = Math.max(1, Math.round(image.height * scale));

	const canvas = document.createElement("canvas");
	canvas.width = width;
	canvas.height = height;

	const context = canvas.getContext("2d");
	if (!context) return null;

	context.drawImage(image, 0, 0, width, height);

	const qualitySteps = [0.82, 0.74, 0.66, 0.58, 0.5, 0.42, 0.35];
	for (const quality of qualitySteps) {
		const dataUrl = canvas.toDataURL("image/jpeg", quality);
		if (
			IMAGE_DATA_URL_PATTERN.test(dataUrl) &&
			dataUrl.length <= MAX_DATA_URL_LENGTH
		) {
			return dataUrl;
		}
	}

	return null;
}

export function resolvePaymentSupportSrc(supportPath?: string | null): string | null {
	if (!supportPath) return null;

	if (/^https?:\/\//i.test(supportPath)) return supportPath;
	if (IMAGE_DATA_URL_PATTERN.test(supportPath)) return supportPath;

	const cleanBase = API_BASE.replace(/\/$/, "");
	const cleanPath = supportPath
		.replace(/^\//, "")
		.replace(/^app\/uploads\//, "")
		.replace(/^uploads\//, "");

	return `${cleanBase}/app/uploads/${cleanPath}`;
}
